'use client'

import { useEffect } from 'react'
import Swiper from 'swiper'
import { CmsBlogList } from '../../../../domain/cmsBlogList'

const useSwiperForBlogLanding = (data: CmsBlogList, className: string) => {
  useEffect(() => {
    if (!data.items.length) {
      return
    }

    const swiperSelector = `.${className} .swiper-container-02`
    const swiperEl = document.querySelector(swiperSelector)

    if (!swiperEl) {
      return
    }

    new Swiper(swiperSelector, {
      spaceBetween: 8,
      slidesPerView: 1,
      breakpoints: {
        1024: {
          enabled: false,
        },
      },
    })
  }, [data.items.length])
}

const SwiperForBlogLandingClient = ({
  data,
  className,
}: {
  data: CmsBlogList
  className: string
}) => {
  useSwiperForBlogLanding(data, className)

  return null
}

export default SwiperForBlogLandingClient
